import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type RootState } from '../../../app/store'

export interface EditSolarProjectState {
  page: number
  showInactiveProjects: boolean
  currentUrlSlug: string | null
  tabIndex: number
  overrideLockedFields: boolean
}

const initialState: EditSolarProjectState = {
  page: 0,
  showInactiveProjects: false,
  currentUrlSlug: null,
  tabIndex: 0,
  overrideLockedFields: false
}

export const editSolarProjectSlice = createSlice({
  name: 'editSolarProject',
  initialState,
  reducers: {
    setDataGridPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload
    },
    setShowInactiveProjects: (state, action: PayloadAction<boolean>) => {
      state.showInactiveProjects = action.payload
    },
    setCurrentUrlSlug: (state, action: PayloadAction<string | null>) => {
      state.currentUrlSlug = action.payload
    },
    setTabIndex: (state, action: PayloadAction<number>) => {
      state.tabIndex = action.payload
    },
    setOverrideLockedFields: (state, action: PayloadAction<boolean>) => {
      state.overrideLockedFields = action.payload
    },
    resetEditSolarProject: (state) => {
      state.currentUrlSlug = null
      state.tabIndex = 0
      state.overrideLockedFields = false
    }
  }
})

export const {
  setDataGridPage,
  setShowInactiveProjects,
  setCurrentUrlSlug,
  setTabIndex,
  setOverrideLockedFields,
  resetEditSolarProject
} = editSolarProjectSlice.actions

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectDataGridPage = (state: RootState): number => state.editSolarProject.page
export const selectShowInactiveProjects = (state: RootState): boolean => state.editSolarProject.showInactiveProjects
export const selectCurrentUrlSlug = (state: RootState): string | null => state.editSolarProject.currentUrlSlug
export const selectTabIndex = (state: RootState): number => state.editSolarProject.tabIndex
export const selectOverrideLockedFields = (state: RootState): boolean => state.editSolarProject.overrideLockedFields

export default editSolarProjectSlice.reducer
